import { fetchClient, HttpClient } from '@cld/session-service';
import { ApplicationsListRaw } from '../../ApplicationWrapper.types';
import { API_BASE_URL } from '@cld/application-wrapper-common';

export const createFetchProductList = (httpClient: HttpClient<{ products: ApplicationsListRaw }>) => (): Promise<ApplicationsListRaw> => {
  const url = `${API_BASE_URL}/customers/product_list`;
  return httpClient(url).then((data) => data?.products);
};

export const fetchProductList = createFetchProductList(fetchClient);
